<template>
  <Modal :value="value" @input="$emit('input', $event)">
    <p class="pb-3 text-sm leading-tight">
      {{ $t('popups.exit.subtitle') }}
    </p>
    <p class="pb-5 text-xl font-medium leading-tight xl:pb-8">
      {{ $t('popups.exit.title') }}
    </p>
    <div class="flex flex-col-reverse sm:flex-row">
      <Button
        id="flight-voucher-return-lh"
        variant="secondary"
        class="mt-4 sm:mt-0 sm:mr-4"
        :href="backToLHLink"
      >
        {{ $t('popups.exit.cancelButton') }}
      </Button>
      <Button
        id="flight-voucher-continue"
        @click="$emit('input', false)"
      >
        {{ $t('popups.exit.continueButton') }}
      </Button>
    </div>
  </Modal>
</template>

<script lang="ts">
import CancelRedemptionPopup from '~app/psp/base/cancel-redemption-popup.ts'
import Modal from '~brand-components/swiss/modal/modal.vue'
import Button from '~brand-components/swiss/button/button.vue'

export default CancelRedemptionPopup.extend({
  components: {
    Modal,
    Button,
  },
})
</script>
